import { User } from '../types';

const hasMembershipType = (user: User, orgType: 'AGENCY' | 'BRAND') =>
  Array.isArray(user.memberships) && user.memberships.some((m) => m.organization?.type === orgType);

export const requiresOrganizationOnboarding = (user: User | null | undefined): boolean => {
  if (!user) return false;
  if (user.role === 'AGENCY') return !hasMembershipType(user, 'AGENCY');
  if (user.role === 'BRAND') return !hasMembershipType(user, 'BRAND');
  return false;
};

export const getRoleHomePath = (user: User | null | undefined): string => {
  if (!user) return '/';
  if (user.role === 'AGENCY') return '/agency/dashboard';
  if (user.role === 'BRAND') return '/brand/dashboard';
  if (user.role === 'KOL') return '/kol/dashboard';
  if (user.role === 'ADMIN') return '/admin/dashboard';
  return '/';
};
